import { Permission } from '@account-users/account/models/Permission';
import { UserRolesAndPermissionsService } from '@account-users/user/services/user-roles-and-permissions.service';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { IUserProfile } from '@account-users';
import { Observable } from 'rxjs';

interface Menu {
  name: string;
  route: string;
  icon: string;
  permissions?: Permission[];
  disabled?: boolean;
  visible?: boolean;
}

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarComponent {
  @Input() isAuthenticated: boolean;
  @Input() permissions: Permission[] = [];
  @Input() user: IUserProfile;

  public Permission = Permission;

  public trialAccountItems: Menu[] = [
    { name: 'Home', route: '/', icon: 'fas fa-home' },
    { name: 'Accounts', route: '/au/accounts/', icon: 'fas fa-address-book' },
    { name: 'Users', route: '/au/users', icon: 'fas fa-users' },
    {
      name: 'Trial account requests',
      route: '/trial-accounts',
      icon: 'fas fa-file-invoice',
    },
  ];

  public items: Menu[] = [
    { name: 'Home', route: '/', icon: 'fas fa-home' },
    { name: 'Accounts', route: '/au/accounts/', icon: 'fas fa-address-book' },
    { name: 'Users', route: '/au/users', icon: 'fas fa-users' },
    {
      name: 'Email Templates',
      route: '/email/template',
      icon: 'fas fa-envelope',
      permissions: [
        Permission.CanWriteEmailTemplate,
        Permission.CanWriteEmailBootstrap,
      ],
    },
    {
      name: 'Email Statistics',
      route: '/statistics/email',
      icon: 'fas fa-chart-line',
    },
    {
      name: 'SMS Statistics',
      route: '/statistics/sms',
      icon: 'fas fa-chart-line',
    },
    {
      name: 'JumpStory Statistics',
      route: '/statistics/jumpstory',
      icon: 'fas fa-chart-line',
    },
    {
      name: 'Prosync Migrations',
      route: '/migrations',
      icon: 'fas fa-file-import',
    },
    // Waiting on Integrations Backend Support
    // {
    //   name: 'Integrations Statistics',
    //   route: '/integrations',
    //   icon: 'fas fa-plug',
    // },
    { name: 'Marketing automation', route: '/ma', icon: 'fas fa-robot' },
    { name: 'Ecom', route: '/ecom', icon: 'fas fa-dollar-sign' },
    {
      name: 'Sender Domain',
      route: '/email/sender-domain',
      icon: 'fas fa-server',
      permissions: [Permission.CanManageSenderDomain],
      disabled: true,
    },
    {
      name: 'Roles & Permissions',
      route: '/roles',
      icon: 'fas fa-user-lock',
    },
    {
      name: 'Custom Domain',
      route: '/private-domain',
      icon: 'fas fa-atlas',
      permissions: [Permission.WawBackOfficePreLaunch],
    },
    {
      name: 'Back Office Stats',
      route: '/boss',
      icon: 'fas fa-chart-line',
    },
    {
      name: 'Trial account requests',
      route: '/trial-accounts',
      icon: 'fas fa-file-invoice',
    },
  ];

  public hasOnlyTrialDispenserRole$: Observable<boolean>;
  public hasUserRoles$: Observable<Boolean>;

  constructor(
    private readonly router: Router,
    private readonly userRolesService: UserRolesAndPermissionsService,
  ) {
    this.hasOnlyTrialDispenserRole$ = this.userRolesService.hasOnlyTrialDispenserRole$;
    this.hasUserRoles$ = this.userRolesService.hasUserRoles$;
  }

  public trackByFn(_: number, { name }: Menu) {
    return name;
  }

  public isActiveRoute(route: string) {
    return this.router.url === route;
  }

  public hasPermission(permissions: Permission[] = []) {
    return (
      !permissions.length ||
      this.permissions.some((permission) => permissions.includes(permission))
    );
  }
}
